import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "./locales/fr/translation.json";
import en from "./locales/en/translation.json";
import es from "./locales/es/translation.json";
import de from "./locales/de/translation.json";
import pt from "./locales/pt/translation.json";
import zhCN from "./locales/zh-CN/translation.json";

export const SUPPORTED = ["fr", "en", "es", "de", "pt", "zh-CN"];
export const LANG_LABELS = { fr: "FR", en: "EN", es: "ES", de: "DE", pt: "PT", "zh-CN": "中文" };
export const LANG_NAMES = {
  fr: "Français", en: "English", es: "Español", de: "Deutsch", pt: "Português", "zh-CN": "简体中文",
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      es: { translation: es },
      de: { translation: de },
      pt: { translation: pt },
      "zh-CN": { translation: zhCN },
    },
    fallbackLng: "fr",
    supportedLngs: SUPPORTED,
    nonExplicitSupportedLngs: false,
    load: "currentOnly",
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "om_lang",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

// Maintient <html lang> synchronisé.
i18n.on("languageChanged", (lng) => {
  try { document.documentElement.setAttribute("lang", lng); } catch (_) {}
});
// Applique aussi la langue au chargement initial (l'événement languageChanged ne se déclenche pas au 1er rendu).
try { document.documentElement.setAttribute("lang", i18n.language || "fr"); } catch (_) {}

export default i18n;
